var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-activity-tile" }, [
    _vm.result.image != null
      ? _c("div", {
          staticClass: "c-activity-tile__image-container",
          style: { backgroundImage: "url(" + _vm.result.image.url + ")" }
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "c-activity-tile__content" }, [
      _vm.result.title
        ? _c("h2", { staticClass: "c-activity-tile__title" }, [
            _vm._v(_vm._s(_vm.result.title))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.result.location && _vm.result.location.name
        ? _c("span", { staticClass: "c-activity-tile__location" }, [
            _vm._v(_vm._s(_vm.result.location.name))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.result.body
        ? _c("p", { staticClass: "c-activity-tile__text" }, [
            _vm._v(_vm._s(_vm.result.body))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.result.url
        ? _c(
            "a",
            {
              staticClass: "c-button c-button--brand",
              attrs: { href: _vm.result.url }
            },
            [_vm._v("View " + _vm._s(_vm.result.type) + " Details")]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-98d48d2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98d48d2c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/entrade/community-search-results/activityResultsCard.vue
// module id = 510
// module chunks = 0